var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41 53v-44c0-1.657-1.343-3-3-3h-34c-1.657 0-3 1.343-3 3v44c0 1.657 1.343 3 3 3h34c1.657 0 3-1.343 3-3z",
    fill: "#703d36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37 52v-41c0-.55-.45-1-1-1h-30c-.55 0-1 .45-1 1v40c0 .55.45 1 1 1z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28 6v4c0 .552-.448 1-1 1h-12c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1h2c0-2.21 1.79-4 4-4s4 1.79 4 4h2c.552 0 1 .448 1 1z",
    fill: "#dce4ea"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    fill: "#2aa869",
    r: 18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m31.384 45.339 5.936 4.433c.478.357 1.151.287 1.545-.161l11.898-13.541c.36-.409.304-1.035-.123-1.374l-3.121-2.487c-.444-.354-1.098-.247-1.406.229l-7.946 12.309-3.039-3.782c-.384-.478-1.114-.478-1.497 0l-2.421 3.013c-.338.421-.26 1.037.173 1.36z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21 6.016c-.553 0-1-.432-1-.984v-.031c0-.553.447-1 1-1s1 .447 1 1-.447 1.016-1 1.016z",
    fill: "#bcc7ce"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24 21h-14c-.553 0-1-.447-1-1s.447-1 1-1h14c.553 0 1 .447 1 1s-.447 1-1 1z",
    fill: "#bcc7ce"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m30 22c-.265 0-.519-.104-.707-.293l-1-1c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l.185.185 2.309-3.077c.331-.442.958-.53 1.399-.2.442.331.532.958.2 1.399l-3 4c-.174.232-.439.377-.729.397-.024.002-.048.003-.071.003z",
    fill: "#2aa869"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bcc7ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 32h-11c-.553 0-1-.447-1-1s.447-1 1-1h11c.553 0 1 .447 1 1s-.447 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 43h-8c-.553 0-1-.447-1-1s.447-1 1-1h8c.553 0 1 .447 1 1s-.447 1-1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.d18f2cf414828073172ab79df9057aea.svg";
export { ForwardRef as ReactComponent };